import { useQuery } from "@tanstack/react-query";

import { api } from "~/shared/services/api/fetch-client.ts";

import type { FtlQuote } from "../atoms/active-ftl-quote";

function getFTLQuote(quoteId: number): Promise<FtlQuote> {
	return api.get(`ftl-quote/${quoteId}`).then((response) => {
		if (!response.ok) throw new Error("Failed to fetch FTL quotes");
		return response.json();
	});
}

export function useFtlQuote(quoteId: number | undefined | null) {
	const { data, error, isLoading } = useQuery({
		queryKey: ["ftl-quotes", quoteId],
		queryFn: async () => {
			// eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- quoteId is guaranteed to be defined due to the enabled condition
			return getFTLQuote(quoteId!);
		},
		enabled: !!quoteId,
		retry: false,
	});

	return {
		data,
		error,
		isLoading,
	};
}
